import React from "react";

const AccountDeletionPolicy = () => {
  return (
    <div className="bg-gray-100 min-h-screen pt-24 px-4 sm:px-6 lg:px-8 flex justify-center">
      <div className="max-w-4xl w-full bg-white shadow-lg rounded-2xl p-6 sm:p-10 mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-gray-800">
          Carmie Account Deletion Policy
        </h1>

        <p className="mb-4 text-gray-700 text-base sm:text-lg leading-relaxed">
          If you wish to delete your Carmie account (Client or Mechanic), please
          follow the steps below:
        </p>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Option 1: Delete your account directly in the app
        </h2>
        <ul className="list-decimal ml-6 text-gray-700 leading-relaxed mb-4">
          <li>Open the Carmie app and go to your Profile section.</li>
          <li>Select “Delete Account” from the menu.</li>
          <li>
            Confirm your choice to permanently delete your account and all
            associated data.
          </li>
          <li>
            Once confirmed, your account and data will be deleted within{" "}
            <strong>7 business days.</strong>
          </li>
        </ul>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Option 2: Request deletion by email
        </h2>
        <p className="mb-4 text-gray-700 leading-relaxed">
          If you are unable to delete your account through the app, you can
          request deletion by email:
        </p>
        <ul className="list-decimal ml-6 text-gray-700 leading-relaxed mb-4">
          <li>
            Send an email to{" "}
            <a
              href="mailto:customercare@carmie.biz"
              className="text-green-600 hover:underline"
            >
              customercare@carmie.biz
            </a>{" "}
            with the subject line “Account Deletion Request.”
          </li>
          <li>
            Include your registered email address or phone number and confirm
            that you want your account deleted.
          </li>
          <li>
            Our support team will verify your identity and process your request
            within 7 business days.
          </li>
        </ul>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Data Deleted:
        </h2>
        <ul className="list-disc ml-6 text-gray-700 leading-relaxed">
          <li>Profile information (name, email, phone number)</li>
          <li>Service and booking history</li>
          <li>Chat messages and reviews</li>
          <li>Any associated location data</li>
        </ul>

        <h2 className="text-xl sm:text-2xl font-semibold mt-6 mb-3 text-gray-800">
          Data Retained (for legal or financial purposes):
        </h2>
        <ul className="list-disc ml-6 text-gray-700 leading-relaxed mb-4">
          <li>Payment and transaction records (kept for up to 90 days)</li>
        </ul>

        <p className="mb-4 text-gray-700 leading-relaxed">
          After deletion, your account cannot be recovered.
        </p>

        <p className="mt-8 text-gray-600 text-sm text-center">
          For any questions about account deletion, contact us at{" "}
          <a
            href="mailto:customercare@carmie.biz"
            className="text-green-600 hover:underline"
          >
            customercare@carmie.biz
          </a>
        </p>
      </div>
    </div>
  );
};

export default AccountDeletionPolicy;
